<template>
  <div></div>
</template>
<script>
export default {
  name: 'small-badge'
}
</script>